import { useMemo, useState } from 'react';
import {
  buildQrValue,
  CONTENT_TYPES,
  DEFAULT_FIELDS,
  DEFAULT_STYLE,
} from '../utils/qrFormats';

export function useQrGenerator() {
  const [contentType, setContentType] = useState(CONTENT_TYPES.url);
  const [fields, setFields] = useState(DEFAULT_FIELDS);
  const [style, setStyle] = useState(DEFAULT_STYLE);

  const qrValue = useMemo(
    () => buildQrValue(contentType, fields),
    [contentType, fields]
  );

  const updateField = (key, value) => {
    setFields((prev) => ({ ...prev, [key]: value }));
  };

  const updateStyle = (key, value) => {
    setStyle((prev) => ({ ...prev, [key]: value }));
  };

  return {
    contentType,
    setContentType,
    fields,
    updateField,
    style,
    updateStyle,
    qrValue,
    hasContent: Boolean(qrValue),
  };
}
